const BASE_KEY = 'account';
const ACCOUNT_ADDITIONAL_DATA_KEY = 'additional-data';
export const API_CACHE_KEY = 'accountsApiCache';

export const accountByIdKey = id => [BASE_KEY, id];

export const additionalDataByNameKey = ({ accountName }) => [BASE_KEY, ACCOUNT_ADDITIONAL_DATA_KEY, accountName];
